import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { ProjectsService } from '../../../../../../modules/projects/core/projects.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../confirm-dialog/confirm-dialog.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CalendarHeaderComponent } from 'src/app/shared/components/calendar-header/calendar-header.component';

@Component({
    selector: 'app-horizontal-date-picker',
    templateUrl: './horizontal-date-picker.component.html',
    styleUrls: ['./horizontal-date-picker.component.scss'],
    standalone: false
})
export class HorizontalDatePickerComponent implements OnInit, OnChanges, OnDestroy {
  // Shared Figma-styled calendar header (chevrons + white-chip tooltip).
  public calendarHeader = CalendarHeaderComponent;
  @Input() date: any = null;
  @Input() count = 7;
  @Input() triggerChange = 0;
  @Output() onDateSelection = new EventEmitter();
  datesList = [];
  selected: false;
  form = new FormGroup({
    date: new FormControl(null),
  });
  protected readonly moment = moment;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private projectsService: ProjectsService,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {
    this.form.controls.date.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(date => {
        this.projectsService.closeRightPanel.next();

        if (this.checkDateNotExist(date)) {
          this.datesList = this.generatePrevDates(date, this.count);
        }

        this.onDateSelection.emit(moment(date).format('YYYY-MM-DD'));
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    let startDate = moment();

    if (this.date) {
      startDate = this.date;
      this.form.controls.date.setValue(startDate, { emitEvent: false });
    }

    this.datesList = this.generatePrevDates(startDate, this.count);
  }

  generatePrevDates(startDate, n) {
    const dates = [];
    for (let i = 0; i < n; i++) {
      dates.push(moment(startDate).subtract(i, 'days'));
    }
    return dates;
  }

  checkDateNotExist(dateToCheck: string): boolean {
    return !this.datesList.some(date => moment(date).isSame(moment(dateToCheck), 'day'));
  }

  selectDate(date) {
    const isFormDirty = this.projectsService.isAnyFormDirty.getValue();

    if (isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.form.controls.date.setValue(date);
          this.projectsService.isAnyFormDirty.next(false);
        }
      });
    } else {
      this.form.controls.date.setValue(date);
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
